export default class Activity {
  constructor() {
    this.transactions = null;
    this.transactionsTotal = 0;
    this.cashFlowInfo = {
      totalYTDDeposit: 0,
      totalYTDWithdrawal: 0,
      totalYTDCashflow: 0,
    };
    this.accountActivity = null;
    this.accountActivityLoaded = false;
    this.accountActivityErrorThrown = false;
  }
}
